<template>
  <div class="profile rj-content">
    <v-overlay :value="loader" z-index="7">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <h1>Usuarios</h1>
    <v-row class="align-center justify-space-between pl-2">
      <!-- <user-search @changeUser="changeUser(), filterDataIdUser()" search-by="display_name" item-text="user_data.display_name" class="user-search"></user-search> -->
      <v-text-field label="Ingrese un usuario" 
          append-outer-icon="mdi-magnify"
          @click:append-outer="inputSearch = searchText"
          :autofocus="true"
          class="user-search excluded"
          v-model="searchText"
          @keyup.enter="inputSearch = searchText"/>
      <span class="d-none">{{loader}}</span>
      <v-btn @click="downloadCsv" class="btn-download" color="primary">Descargar usuarios</v-btn>
    </v-row>
    <!--<p class="placeholder" v-if="!currentUser || !user.info.user_data.id">Ingresa y seleciona un usuario para ver y editar su información.</p>-->
    <div 
      class="text-right mb-0 pb-0 pt-0 pr-1 container"
      v-if="currentUser && user.info.user_data.id"> 
      <v-btn
        color="teal" dark text x-small 
        @click="backToTable"
        style="width: auto;"
        class="close-profile" >
        <v-icon small>mdi-chevron-left</v-icon> Volver
      </v-btn>
    </div>
    <div class="container" v-if="currentUser && user.info.user_data.id">
      <v-card @changeUser="changeUser(), filterDataIdUser()">
        <v-card-text>
          <v-expansion-panels
              v-model="panels"
              :multiple="true"
              :flat="true">
            <v-expansion-panel>
              <div class="edit-btn" @click="editSection(user)">
                <i :class="!user.editable?'active':''"></i>
              </div>
              <v-expansion-panel-header>
                Mis datos
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-form
                    ref="userFormRef"
                    v-model="userForm"
                    lazy-validation
                >
                  <label for="">Nombres</label>
                  <v-text-field
                      v-model="user.info.user_data.names"
                      :rules="validationRules.required"
                      :name="Math.random()"
                      placeholder=""
                      required
                      :disabled="user.editable"
                  ></v-text-field>
                  <label for="">Apellidos</label>
                  <v-text-field
                      v-model="user.info.user_data.surnames"
                      :rules="validationRules.required"
                      :name="Math.random()"
                      placeholder=""
                      required
                      :disabled="user.editable"
                  ></v-text-field>
                  <label for="">Documento de identidad</label>
                  <v-text-field
                      v-model="user.info.user_data.document"
                      :rules="validationRules.required"
                      :name="Math.random()"
                      type="text"
                      max="15"
                      placeholder=""
                      required
                      :disabled="user.editable"
                  ></v-text-field>
                  <label for="">País de residencia actual</label>
                  <v-select
                      v-model="user.info.user_data.current_country"
                      :items="countries"
                      item-text="country"
                      item-value="country"
                      placeholder="Selecciona un pais"
                      :rules="validationRules.required"
                      :name="Math.random()"
                      :disabled="user.editable"
                  ></v-select>
                  <label for="">Estado o departamento de residencia actual</label>
                  <v-select
                      v-model="user.info.user_data.current_place"
                      :items="states[0].states"
                      :rules="validationRules.required"
                      :name="Math.random()"
                      placeholder="Selecciona un estado"
                      required
                      :disabled="user.editable || !states[0].country"
                  ></v-select>
                  <label for="">Celular</label>
                  <br/>
                  <!--Ver dial_code para guardarlo-->
                  <div class="phone-dial-ctn">
                    <v-select
                        v-model="user.info.user_data.phone_dial"
                        class="phone-dial"
                        :items="phones"
                        item-value="dial_code"
                        :disabled="user.editable"
                        :rules="validationRules.required"
                      :name="Math.random()"
                        required
                    >
                      <template v-slot:item="{item}">
                        {{ item.name }}
                      </template>
                      <template v-slot:selection="{ item }">
                        <img :src="'/flags/'+item.code+'.png'" alt=""/>
                      </template>
                    </v-select>
                    <v-text-field
                        class="phone-value"
                        v-model="user.info.user_data.phone"
                        :rules="validationRules.required"
                        onKeypress="if (event.keyCode < 45 || event.keyCode > 57) event.returnValue = false;"
                      :name="Math.random()"
                        required
                        placeholder=""
                        :disabled="user.editable"
                    >
                    </v-text-field>
                  </div>
                  <label for="">Correo electrónico</label>
                  <v-text-field
                      v-if="user.info.user_data.user"
                      v-model="user.info.user_data.user[0].email"
                      :rules="validationRules.required"
                      :name="Math.random()"
                      type="mail"
                      placeholder=""
                      required
                      :disabled="true"
                  ></v-text-field>
                  <label for="">Fecha y hora de nacimiento</label>
                  <v-datetime-picker
                      v-model="user.info.user_data.birth_date"
                      :rules="validationRules.required"
                      :name="Math.random()"
                      dateFormat="yyyy-MM-dd"
                      timeFormat="HH:mm:ss"
                      width="340px"
                      placeholder=""
                      required
                      :disabled="user.editable">
                    <template slot="actions" slot-scope="{ parent }">
                      <v-btn text color="primary" @click="parent.okHandler">OK</v-btn>
                    </template>
                    <template slot="dateIcon">
                      <v-icon>mdi-calendar</v-icon>
                    </template>
                    <template slot="timeIcon">
                      <v-icon>mdi-timer</v-icon>
                    </template>
                  </v-datetime-picker>
                  <label for="">País de nacimiento</label>
                  <v-select
                      v-model="user.info.user_data.born_country"
                      :items="countries"
                      item-text="country"
                      item-value="country"
                      placeholder="Selecciona un pais"
                      :rules="validationRules.required"
                      :name="Math.random()"
                      :disabled="user.editable"
                  ></v-select>
                  <label for="">Estado o departamento de nacimiento</label>
                  <v-select
                      v-model="user.info.user_data.born_place"
                      :items="statesBorn[0].states"
                      :rules="validationRules.required"
                      :name="Math.random()"
                      placeholder="Selecciona un estado"
                      required
                      :disabled="user.editable || !statesBorn[0].country"
                  ></v-select>
                </v-form>
                <v-btn outlined v-if="!user.editable" class="save-btn " color="primary" @click="editSection(user)">Cancelar</v-btn>
                <v-btn color="primary" class="save-btn ml-4" v-if="!user.editable" @click="updateUserInfo">
                  Guardar cambios
                </v-btn>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <div class="edit-btn" @click="editSectionBirth()">
                <i :class="!user.editableBirth?'active':''"></i>
              </div>
              <v-expansion-panel-header>Celebración de cumpleaños</v-expansion-panel-header>
              <v-expansion-panel-content>
                <p class="details">Ingresa la información respecto a la última celebración de tu cumpleaños.</p>
                <label for="">País</label>
                <v-select
                    v-model="user.info.user_data.last_birthday_country"
                    :items="countries"
                    item-text="country"
                    item-value="country"
                    placeholder="Selecciona un pais"
                    :rules="validationRules.required"
                      :name="Math.random()"
                    :disabled="user.editableBirth"
                ></v-select>
                <label for="">Estado o departamento</label>
                <v-select
                    v-model="user.info.user_data.last_birthday_place"
                    :items="statesLastBirth[0].states"
                    :rules="validationRules.required"
                      :name="Math.random()"
                    placeholder="Selecciona un estado"
                    required
                    :disabled="user.editableBirth || !statesLastBirth[0].country"
                ></v-select>
                <v-btn outlined v-if="!user.editableBirth" class="save-btn " color="primary" @click="editSectionBirth(user)">Cancelar</v-btn>
                <v-btn color="primary" class="save-btn ml-4" v-if="!user.editableBirth" @click="updateUserInfo">
                  Guardar cambios
                </v-btn>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Mi(s) hijo(s)</v-expansion-panel-header>
              <v-expansion-panel-content>
                <children></children>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Mi pareja</v-expansion-panel-header>
              <v-expansion-panel-content>
                <p class="details">Ingresa la información de tu pareja. Puede ser tu esposo, esposa, conviviente,
                  enamorado o enamorada
                  o cualquier tipo de pareja sin importar el estatus legal.</p>
                <couple></couple>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Mascotas</v-expansion-panel-header>
              <v-expansion-panel-content>
                <pet></pet>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Pérdida de embarazo</v-expansion-panel-header>
              <v-expansion-panel-content>
                <p class="details">Ingresa la información de las pérdidas de embarazo que tú o tu pareja hayan podido
                  tener.</p>
                <miscarriage></miscarriage>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Mudanza</v-expansion-panel-header>
              <v-expansion-panel-content>
                <p class="details">Ingresa la información de la última mudanza que hayas hecho.</p>
                <moves></moves>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-row class="justify-center mb-5 mt-5">
            <v-btn color="primary" class="btn-download" @click="downloadCsvByEmail">Descargar datos</v-btn>
          </v-row>
          <v-row class="justify-center mb-5 mt-5">
            <v-btn v-if="allData[0]" color="primary" class="btn-download" @click="imgModal(allData[0].id)">Ver Carta astral</v-btn>
            <v-btn v-else color="primary" class="btn-download" :to="'carta-astral?agregarCartaAstral'">Agregar Carta astral</v-btn>
          </v-row>

          <v-dialog v-model="dialogImg" max-width="650px">
            <v-card>
              <v-col class="text-end">
                <v-icon color="gris" @click="dialogImg = false">mdi-close</v-icon>
              </v-col>
              <v-img :src="imgUrl"></v-img>
            </v-card>
          </v-dialog>

        </v-card-text>
      </v-card>
    </div>
    <users-table :search-user="inputSearch" @changeUser="changeUser(), filterDataIdUser()"  v-else></users-table>
    <!-- <p class="placeholder" v-else>Ingresa y seleciona un usuario para ver y editar su información.</p> -->
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
import {phones} from "../assets/js/phones.js"
import {countries} from "../assets/js/countries.js"
import Children from "../components/Children"
import Couple from "../components/Couple"
import Pet from "../components/Pet"
import Miscarriage from "../components/Miscarriage"
import Moves from "../components/Moves"
// import UserSearch from "../components/UserSearch"
import UsersTable from "../components/UsersTable"
// import axios from 'axios'

export default {
  name: 'Profile',
  components: {Children, Couple, Pet, Miscarriage, Moves, UsersTable},
  data: () => ({
    inputSearch: '',
    searchText: '', 
    panels: [0, 1, 2, 3, 4, 5, 6],
    panel: [],
    phones: phones,
    countries: countries,
    userForm: false,
    validationRules: {
      required: [
        v => !!v || 'Debe ingresar un valor para este campo',
      ],
    },
    user: {
      editable: true,
      editableBirth: true,
      info: {
        "user": {
          "id": "",
          "email": "",
          "user_image": "",
          "display_name": "",
          "user_type": 1
        },
        "user_data": {
          "names": "",
          "surnames": "",
          "document": "",
          "phone": "",
          "current_country": "",
          "current_place": "",
          "birth_date": "",
          "born_place": "",
          "born_country": "",
          "last_birthday_country": "",
          "last_birthday_place": "",
          "user": ""
        }
      }
    },
    loader: false,
    birthday: {},
    required: [],
    phoneDial: {"name": "Peru", "dial_code": "+51", "code": "pe"},
    dialogImg: false,
    imgUrl: '',
  }),
  computed: {
    ...mapState('user', [
      'info',
      "currentUser",
    ]),
    ...mapState('astralCard', [
      'data', 'allData']),
    ...mapState('csvData', ['postData']),
    ...mapState(['mainLoader']),
    states() {
      let country = countries.filter((item) => {
        return item.country == this.user.info.user_data.current_country
      })
      if (!country.length) {
        country = [{}]
      }
      return country
    },
    statesLastBirth() {
      let country = countries.filter((item) => {
        return item.country == this.user.info.user_data.last_birthday_country
      })
      if (!country.length) {
        country = [{}]
      }
      return country
    },
    statesBorn() {
      let country = countries.filter((item) => {
        return item.country == this.user.info.user_data.born_country
      })
      if (!country.length) {
        country = [{}]
      }
      return country
    },
  },
  watch: {
    'info': function () {
      this.user.info = JSON.parse(JSON.stringify(this.info))
    },
    'user.editable': function () {
      this.user.info = JSON.parse(JSON.stringify(this.info))
    }
  },
  methods: {
    ...mapActions(
        'user', [
          'fetchInfo',
          'updateInfo',
          'fetchAllCSV',
          'fetchUserCSV',
          'updateCurrentUser'
        ]
    ),
    ...mapActions('child', ['fetchChildren',]),
    ...mapActions('couple', {fetchCouple: 'fetchData'}),
    ...mapActions('miscarriage', {fetchMiscarriage: 'fetchData'}),
    ...mapActions('moves', {fetchMoves: 'fetchData'}),
    ...mapActions('pet', {fetchPet: 'fetchData'}),
    ...mapActions(['loaderChange']),
    ...mapActions('csvData', ['fetchCsv']),

    ...mapActions(
        'astralCard', [
          'fetchDataAllAstralCard',
          'updateAstralCard',
          'updateData',
          'removeAstralCard',
          'addUserAstralCard',
          'fetchAstralCardUserId'
        ]
    ),

    filterDataIdUser() {
      this.loaderChange(true)
      let request = {
        id: this.currentUser
      }
      this.fetchAstralCardUserId(request).finally(() => {
        this.loaderChange(false)
      })
    },

    imgModal(id) {
      this.arrayObjImg = this.allData.find(x => x.id === id);
      this.dialogImg = true
      this.imgUrl = this.arrayObjImg.file_url
    },

    editSection() {
      this.user.editable = !this.user.editable
    },
    editSectionBirth() {
      this.user.editableBirth = !this.user.editableBirth
    },
    fetchUserData() {
      this.loader = true
      this.fetchInfo().then(() => {
        this.loader = false
      })
    },
    updateUserInfo() {
      let valid = this.$refs.userFormRef.validate()
      if (valid) {
        this.loaderChange(true)
        this.updateInfo(this.user).finally(() => {
          this.loaderChange(false)
          this.user.editableBirth = true
          this.user.editable = true
        })
      } else  {
        const el = this.$el.querySelector(".v-messages.error--text:first-of-type")
        this.$vuetify.goTo(el, { offset: + 55 })
      }
    },
    changeUser() {
      this.fetchUserData()
      this.fetchChildren()
      this.fetchCouple()
      this.fetchMiscarriage()
      this.fetchMoves()
      this.fetchPet()
    },
    async downloadCsv() {
      this.loader = true
      this.fetchAllCSV().then(()=>{
        this.loader = false
      })
    },
    async downloadCsvByEmail() {
      this.loader = true
      this.fetchUserCSV(this.user.info.user_data.user[0].email).then(()=>{
        this.loader = false
      })
    },
    backToTable() {
      this.updateCurrentUser("");
    }
  },
  mounted() {
    /*if (!localStorage.getItem('token')) {
      sessionStorage.setItem('url', window.location.href);
    }*/
    if (localStorage.getItem('showThisUser')) {
      this.changeUser()
      this.filterDataIdUser()
      localStorage.removeItem('showThisUser')
    }
  }
}
</script>
<style lang="scss" scoped>
@mixin mobile {
  @media screen and (max-width: 768px) {
    @content;
  }
}
.profile {
  width: 100%;

  ::v-deep .v-expansion-panel {
    border-bottom: 1px solid #DEE3E6;
    margin-top: 0;

    &:last-child {
      border-bottom: 0;
    }

    > button {
      padding: 20px 8px 18px 8px;
      min-height: auto;
    }

    .v-expansion-panel-header {
      font-weight: 800;
      color: #656565;
      font-size: 20px;

      .v-expansion-panel-header__icon {
        margin-left: 8px;

        .v-icon {
          color: #B3B3B3 !important;
        }
      }
    }

    .v-expansion-panel-content__wrap {
      padding: 0 10px 16px;
    }
  }
}

.details {
  font-size: 12px;
  font-weight: 200;
}

.ctn-btn {
  font-weight: 200;
  margin-top: 20px;

  ::v-deep .v-btn {
    background-color: #2C8886;
  }

  label {
    margin-left: 12px;
    vertical-align: middle;
    font-weight: 200;
  }
}

.save-btn {
  margin: 35px 0 20px;
  text-transform: none;
  font-size: 14px;
  width: 160px;
  border-radius: 7px;
  height: 40px;
}

::v-deep .v-input:not(.excluded) {
  width: 250px;
  .v-messages__message {
    padding-top: 3px;
  }
  &.v-input--is-disabled {
    .v-input__slot::before {
      display: none;
    }

    .v-input__append-inner {
      display: none;
    }

    .v-text-field__details {
      display: none;
    }
  }

  .v-text-field__details {
    min-height: 0;

    .v-messages, .v-text-field__details {
      min-height: 0;
    }
  }

  .v-input__slot {
    margin-bottom: 0;

    .v-text-field__slot, .v-select__selections {
      input, .v-select__selection {
        color: #656565;
      }
    }
  }
}

.phone-dial, .phone-value {
  display: inline-block;
  vertical-align: top;
}

.phone-dial {
  width: 53px;
  margin-right: 8px;

  &.v-input--is-disabled {
    width: 25px;
  }
}

.phone-value {
  width: 190px;

  ::v-deep .v-input__slot {
    height: 29px;
  }
}

::v-deep .v-picker__body {
  background: red;
  width: 90% !important;
  margin: 0 auto;

  .accent--text button, td .v-btn__content {
    color: #656565;
  }
}

.phone-dial-ctn {
  vertical-align: top;
}

.placeholder {
  color: #656565;
  padding: 0 5px;
}

.user-search {
  margin: 25px 0 5px;
  padding: 0 5px;
  max-width: 40%;
  @include mobile {
    width: 100%;
  }
}
  @include mobile {
    .btn-download {
      display: none;
    }
  }
.save-btn.ml-4 {
  @include mobile {
    margin-left: auto !important;
  }
}
.close-profile {
  font-size:12px;
}
</style>
